import React, { useEffect, useState } from "react";
import { ReactComponent as PlayIcon } from "../../../assets/icons/play.svg";
import { ReactComponent as PauseIcon } from "../../../assets/icons/pause.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete.svg";
import { ReactComponent as EditIcon } from "../../../assets/icons/edit.svg";
import Table from "../../../components/Table/Table";
import { ReactComponent as AddItemIcon } from "../../../assets/icons/add.svg";
import ActionButton from "../../../components/Buttons/ActionButton";
import {
  useModel,
  useModels,
} from "../../../Api/newSockets.api";
import { useHistory, useLocation } from "react-router";
import Search from "../../../components/Search/Search";
import AddButton from "../../../components/Buttons/AddButton";
import Input from "../../../components/DataEntry/Input";
import Modal from "../../../components/Modals/Modal";

// import models from "../../../assets/mockedData/models";
import Header from "../../../components/Header/Header";
import data_tab_data from "../../../assets/mockedData/data_tab_data";
import Tabs from "../../../components/Tabs/Tabs";
import Select from "../../../components/DataEntry/Select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrimaryButton from "../../../components/Buttons/PrimaryButton";
import OutlinedButton from "../../../components/Buttons/OutlinedButton";
import validator from "validator";
import { savePathToLocalStorage } from "../../../utils/helpers";

const Models = () => {
  savePathToLocalStorage();
  const { models, searchModels, connected } = useModels();
  const { addModel, trainModel, stopModel, deleteModel } = useModel();

  const [modalOpen, setModalOpen] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [name, setName] = useState("");
  const [typeId, setTypeId] = useState("");
  const [params, setParams] = useState("");
  const [validationErrors, setValidationErrors] = useState({
    name: "",
    typeId: "",
    params: "",
  });
  const [loading, setLoading] = useState(false);
  const [dataTabData, setDataTabData] = useState(data_tab_data);
  const [searchValue, setSearchValue] = useState("");
  const [row, setRow] = useState({ name: "" });
  const history = useHistory();

  // Map typeId to display name
  const typeIdToName = (typeId: number) => {
    switch (typeId) {
      case 1:
        return "Images";
      case 2:
        return "Time Series";
      default:
        return "Unknown";
    }
  };

  const headers = [
    {
      label: "Name",
      key: "name",
      type: "text",
    },
    {
      label: "Type",
      key: "typeId",
      type: "text",
      format: typeIdToName,
    },
    {
      label: "Status",
      key: "status",
      type: "badge",
    },
    {
      label: "Date created",
      key: "dateCreated",
      type: "date",
    },
  ];

  const filterModels = (searchValue) => {
    setSearchValue(searchValue);
  };

  useEffect(() => {
    if (!connected) return;
    searchModels(searchValue).then((data: any) => console.log("my data", data)).catch(() => {});
  }, [connected, searchValue]);

  const validateFields = () => {
    var formValidated = true;
    var newValidationErrors = { name: "", typeId: "", params: "" };

    if (validator.isEmpty(name)) {
      newValidationErrors = { ...newValidationErrors, name: "Invalid name" };
      formValidated = false;
    }
    if (!validator.isInt(typeId)) {
      newValidationErrors = {
        ...newValidationErrors,
        typeId: "Invalid type",
      };
      formValidated = false;
    }
    if (params.trim()) {
      try {
        JSON.parse(params);
      } catch {
        newValidationErrors = {
          ...newValidationErrors,
          params: "Invalid JSON",
        };
        formValidated = false;
      }
    }
    setValidationErrors(newValidationErrors);
    return formValidated;
  };

  const handleSubmitModel = () => {
    if (validateFields()) {
      const model = {
        name: name,
        typeId: parseInt(typeId),
        params: params.trim() ? JSON.parse(params) : {},
        status: "Untrained",
        dateCreated: new Date(),
        dateModified: new Date(),
      };
      console.log(model);
      addModel(model).then((data: any) => {
        history.push(`/data/models/${data.id}`);
      });
    }
  };

  const handleNewModel = () => {
    setModalOpen(true);
  };

  const onClose = (info) => {
    if (info == "error") {
      setErrorModal(false);
    } else if (info == "add") {
      setModalOpen(false);
    }
  };

  // ErrorMessage handle error that we get from promise and display it in toastify
  const ErrorMessage = ({ error }) => <div>{error}</div>;
  const toasti = (error) => {
    toast.error(<ErrorMessage error={error} />, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const deleteModel_ = (row) => {
    setLoading(true);
    deleteModel(row.id)
      .then((response) => setErrorModal(false))
      .then(() => setLoading(false))
      .catch((err) => {
        console.log(err);
        setErrorModal(false);
        setLoading(false);
        toasti(err.message);
      });
  };

  const actions = (row: any) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [activeButton, setActiveButton] = useState(false);
    const handlePlay = (e, row) => {
      e.persist();
      e.stopPropagation();
      e.preventDefault();
      const modelId = row.id;
      setActiveButton(!activeButton);
      trainModel(modelId)
        .then((data: any) => {
          console.log(data);
        })
        .catch((err) => {
          console.log(err);
          toasti(err.message);
        });
    };
    const handleStop = (e, row) => {
      e.stopPropagation();
      e.preventDefault();
      e.persist();
      const modelId = row.id;
      setActiveButton(!activeButton);
      stopModel(modelId)
        .then((data: any) => {
          console.log(data);
        })
        .catch((error) => {
          toasti(error.message);
        });
    };
    //
    const openDeleteModal = (e, row) => {
      console.log(row);
      e.stopPropagation();
      e.preventDefault();
      setRow(row);
      setErrorModal(true);
    };

    const handleEdit = (e, row) => {
      e.stopPropagation();
      e.preventDefault();
      alert("You clicked edit");
    };

    return (
      <>
        {row.status == "Training" ? (
          <div style={{ display: "flex" }}>
            <ActionButton
              icon={<PauseIcon />}
              className="list-item-action"
              onClick={(e) => handleStop(e, row)}
            />
            <ActionButton
              icon={<EditIcon />}
              className="list-item-action"
              onClick={(e) => handleEdit(e, row)}
            />
            <ActionButton
              icon={<DeleteIcon />}
              className="list-item-action"
              onClick={(e) => openDeleteModal(e, row)}
            />
          </div>
        ) : (
          <div style={{ display: "flex" }}>
            <ActionButton
              icon={<PlayIcon />}
              className="list-item-action"
              onClick={(e) => handlePlay(e, row)}
            />
            <ActionButton
              icon={<EditIcon />}
              className="list-item-action"
              onClick={(e) => handleEdit(e, row)}
            />
            <ActionButton
              icon={<DeleteIcon />}
              className="list-item-action"
              onClick={(e) => openDeleteModal(e, row)}
            />
          </div>
        )}
      </>
    );
  };

  // Delete modal footer

  var footer = (
    <>
      <PrimaryButton
        className="delete-button-background-color"
        onSubmit={() => deleteModel_(row)}
        loading={loading}
      >
        Delete
      </PrimaryButton>
      <OutlinedButton onClick={() => onClose("error")}>Cancel</OutlinedButton>
    </>
  );

  return (
    <div>
      <Header
        title="Models"
        searchFunction={filterModels}
        mainAction={
          <AddButton
            icon={<AddItemIcon />}
            label="New model"
            onClick={handleNewModel}
          />
        }
      />
      {models && (
        <div className="main-content-flex">
          <Tabs data={dataTabData} />
          <div className="section">
            <Table
              items={models}
              headers={headers}
              // to="data/models"
              tableName="models"
              actions={actions}
            />
          </div>
        </div>
      )}

      <ToastContainer
        autoClose={5000}
        position="bottom-right"
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      {/* User input modal */}
      <Modal
        visible={modalOpen}
        onClose={() => onClose("add")}
        title="Add new model"
        onSubmit={handleSubmitModel}
        submitLoading={loading}
      >
        <Input
          placeholder="Enter a name"
          onChange={(e: any) => setName(e.target.value)}
          status={validationErrors.name && "error"}
          className="input-classic"
          validationMessage={validationErrors.name}
          onPressEnter={handleSubmitModel}
        />
        <Select
          placeholder="Select type"
          options={[
            { id: 1, name: "Images" },
            { id: 2, name: "Time Series" },
          ]}
          onChange={(e: any) => setTypeId(e.target.value)}
          className="select-classic"
          status={validationErrors.typeId && "error"}
          validationMessage={validationErrors.typeId}
          onPressEnter={handleSubmitModel}
        />
        <Input
          placeholder="Params (JSON)"
          onChange={(e: any) => setParams(e.target.value)}
          status={validationErrors.params && "error"}
          className="input-classic"
          validationMessage={validationErrors.params}
          onPressEnter={handleSubmitModel}
        />
      </Modal>

      {/* Delete modal */}

      <Modal
        title={`Delete ${row && row.name} ?`}
        subtitle={"Warning: this can't be undone"}
        desc="By deleting this model you will lose all images related to the model"
        visible={errorModal}
        footer={footer}
        onClose={() => onClose("error")}
      />
    </div>
  );
};

export default Models;
